import actions from "@/store/modules/lottery/actions";
import mutations from "@/store/modules/lottery/mutations";
import state from "@/store/modules/lottery/state";

export default {
    actions,
    mutations,
    state
}